import React from "react";
import { Svg } from "../uikit-b2c/Svg";






export function Ffr() {
  return (
  <div style={{display: 'flex'}}>
  <div className="xsbps_block" style={{
          width: 'auto',
          backgroundColor: 'white',
          borderRadius: 4,
          margin:0,
        }}>
      <div className="xsbps_ref0">
        <div className="xsbps_ref" style={{
          lineHeight: '1em',
          display: 'flex',
          padding: '8px 16px 6px 16px',
          alignItems: 'center',
          borderRadius: 4,
          backgroundColor: 'rgba(145, 214, 189, 0.32)',
          color: '#00c77e',
        }}>
         <p className="xsbps_ref_h2" style={{
              marginBottom: 4,
              fontSize: 12,
              fontWeight: 500,
            }}>Loyal refund policy (?)</p>

        </div>
      </div>
      </div>
  </div>);
}




export function Ffr2() {
  return (<div>
    <div className="xsbps_block" style={{
          backgroundColor: 'white',
          borderRadius: 4,
        }}>
      <div className="xsbps_ref0">
        <div className="xsbps_ref" style={{
          lineHeight: '1.3em',
          display: 'flex',
          padding: '12px 16px',
          alignItems: 'center',
          borderRadius: 4,
          backgroundColor: 'rgba(145, 214, 189, 0.32)',
          color: '#00c77e',
        }}>
          <div className="xsbps_ref_icon" style={{
            width: 52,
            height: 52,
            marginRight: 12,
            flex: '0 0 auto',
          }}>
            <div className="xsbps_ref_icon w-embed">
            <Svg
              width={48}
              height={48}
              color='#cccccc'
              // color={theme['colorText']}
              >{ffr1}</Svg>
            </div>
          </div>
          <div className="xsbps_right" style={{
            lineHeight: '1.3em',
            color: '#00c77e',
            fontSize: 14,
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
          }}>
            <p className="xsbps_ref_h2" style={{
              marginBottom: 4,
              fontSize: 12,
              fontWeight: 500,
            }}>Loyal refund policy</p>
            <p className="xsbps_ref_noti" style={{
              marginBottom: 0,
              fontSize: 12,
              lineHeight: '1.2em',
            }}>
              A refund guarantee for a pre-order until any playable content
                has been delivered.{" "}
              <a href="#" className="a" style={{color: 'currentColor'}}>
                Read more
                </a>{" "}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>);
}



const ffr1 = `<svg className="xsbps_ref_icon1" xmlns="http://www.w3.org/2000/svg" width={48} height={48}>
<g fill="none" fillRule="evenodd" stroke="currentColor" strokeWidth={2}>
  <path d="M13.1 11.45v11.5-11.4c0-1.1-.8-2.1-2-2.1s-2.1.8-2.1 2v11.4-11.4c0-1.1-.9-2-2-2s-2 .9-2 2v16.3-5.8c0-1.7-1.3-3-3-3H1v8.9c0 2 .7 3.9 1.9 5.5l2.8 3.7c.3.3.5.7.5 1.2v9.7m10.8-25l.1-9.3m1.8 34.3v-10.2c1.3-3.4 2-7.1 2-10.8v-10" />
  <path d="M13 30.95c0-2.2-1.8-4-4-4H3.9m19-23.6l-.7-.7c-2.2-2.2-5.8-2.2-8 0s-2.2 5.8 0 8l8.7 8.7 8.7-8.7c2.2-2.2 2.2-5.8 0-8s-5.8-2.2-8 0l-.7.7zm9.9 8.1v11.5-11.4c0-1.1.8-2.1 2-2.1 1.1 0 2.1.8 2.1 2v11.6-11.6c0-1.1.9-2 2-2s2 .9 2 2v16.3-5.8c0-1.7 1.3-3 3-3h1v8.9c0 2-.7 3.9-1.9 5.5l-2.8 3.7c-.3.3-.5.7-.5 1.2v9.7m-10.8-25l-.1-9.3" />
  <path d="M27 47.95v-10.2c-1.3-3.4-2-7.1-2-10.8v-10m7.9 14c0-2.2 1.8-4 4-4h4" />
</g>
</svg>`
